import styled, { css } from "styled-components";
import { visuallyHidden } from "@m/alchemy-theme";
import { SearchIcon } from "../../icons/SearchIcon";
import { IconButton } from "../../icon-button/IconButton";
import { Field } from "../field/Field";
import { FieldAdornment } from "../field-adornment/FieldAdornment";
export const SearchFieldIcon = styled(SearchIcon) `
  // TODO: allow non-interactive adornments in Field directly
  ${FieldAdornment}:has(> &) {
    pointer-events: none;
  }
  margin-left: 0;
`;
export const ClearButton = styled(IconButton) ``;
export const SearchField = styled(Field) `
  input::-webkit-search-cancel-button {
    display: none;
  }

  ${ClearButton}:not(:focus) {
    ${({ isClearButtonHidden }) => isClearButtonHidden &&
    css `
        ${visuallyHidden()}
      `}
  }
`;
